var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"card-details-modal","title":"Dettagli della card","scrollable":"","centered":"","ok-only":"","ok-variant":"secondary","ok-title":"Chiudi"}},[_c('CardDescription',{attrs:{"card":_vm.activeCard}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }